var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTransactionReportDownload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.0005C1 5.58634 1 3.37929 2.37129 2.00801C3.74257 0.636719 5.94963 0.636719 10.3637 0.636719C14.7778 0.636719 16.9849 0.636719 18.3562 2.00801C19.7275 3.37929 19.7275 5.58634 19.7275 10.0005C19.7275 14.4145 19.7275 16.6217 18.3562 17.9929C16.9849 19.3642 14.7778 19.3642 10.3637 19.3642C5.94963 19.3642 3.74257 19.3642 2.37129 17.9929C1 16.6217 1 14.4145 1 10.0005Z",
    fill: "#807EEC",
    stroke: "#807EEC",
    strokeWidth: 0.585234
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17578 12.5C5.17578 14.312 5.17578 15.2179 5.73869 15.7808C6.30159 16.3438 7.20757 16.3438 9.01953 16.3438H12.8633C14.6752 16.3438 15.5812 16.3438 16.1441 15.7808C16.707 15.2179 16.707 14.312 16.707 12.5",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9414 4.81153V13.1396M10.9414 13.1396L13.5039 10.3369M10.9414 13.1396L8.37891 10.3369",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransactionReportDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TransactionReportDownload.5ba0ccc3.svg";
export { ForwardRef as ReactComponent };